module.exports = __webpack_public_path__ + "static/media/dashboard-background.edba1204.png";